export default __webpack_public_path__ + "transfix-maps/icons/P3.c24dd3ae2408dc1a2be3eeb56a52b56e.png";